<template>
    <swiper-slide class="swiper-item">
        <slot></slot>
    </swiper-slide>
</template>

<script>
import { SwiperSlide } from "vue-awesome-swiper";

export default {
    name: "TaplinkSwiperItem",
    components: {
        SwiperSlide
    }
};
</script>

<style lang="scss">
.swiper-slide.swiper-item {
    width: 100% !important;
}
</style>
